export default "__VITE_ASSET__DyAowyCw__"